import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  applyCoupon,
  ApplyCouponParams,
  ApplyCouponResponse,
  getCouponHistory,
  GetCouponHistoryParams,
} from '.';
import { AxiosError, AxiosResponse } from 'axios';

export const COUPON_HISTORY_KEY = ['coupon-history'];

export const useApplyCoupon = () => {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponse<ApplyCouponResponse>,
    AxiosError<{ message?: string }>,
    ApplyCouponParams
  >({
    mutationFn: applyCoupon,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: COUPON_HISTORY_KEY });
    },
  });
};

export const useGetCouponHistory = (params?: GetCouponHistoryParams) => {
  return useQuery({
    queryKey: [...COUPON_HISTORY_KEY, params],
    queryFn: () => getCouponHistory(params),
  });
};
